// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import carousel from 'v-owl-carousel'
import VueProgressBar from 'vue-progressbar'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/css/font-awesome.min.css'
import './assets/css/animate.min.css'
import './assets/index.scss'
import { firestorePlugin } from "vuefire";
import VueCoreVideoPlayer from 'vue-core-video-player'
import VueLazyLoad from 'vue-lazyload'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueHtml2Canvas from 'vue-html2canvas';
Vue.use(VueLazyLoad)
Vue.use(VueAxios, axios)

Vue.use(VueCoreVideoPlayer)

Vue.use(BootstrapVue)
Vue.use(VueAwesomeSwiper)
Vue.use(VueHtml2Canvas)
Vue.use(firestorePlugin)
Vue.component('carousel', carousel)
Vue.config.productionTip = false
const options = {
  color: '#FFFFFF',
  failedColor: '#874b4b',
  thickness: '2px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
}
Vue.use(VueProgressBar, options)

/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

